import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let SearchBox = class SearchBox extends Vue {
    constructor() {
        super(...arguments);
        this.searchText = '';
    }
    created() {
        this.setText();
    }
    setText() {
        this.searchText = this.$route.query.searchText;
    }
    handleSubmit() {
        if (this.searchText)
            this.$router.push({ path: '/searchResults', query: { searchText: this.searchText } });
    }
    handleInput({ code }) {
        if (code === 'Enter')
            this.handleSubmit();
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], SearchBox.prototype, "isClearable", void 0);
__decorate([
    Watch('$route')
], SearchBox.prototype, "setText", null);
SearchBox = __decorate([
    Component
], SearchBox);
export default SearchBox;
